function filterAlpha(value){
    return  value.replace(/[^a-zA-ZÑñ ]/g, "");
}
function filterNumber(value){
    return value.replace(/[^0-9]/g, "");
}

export {
    filterAlpha,
    filterNumber
}